module.exports = __webpack_public_path__ + "static/media/d20.6e17526c.png";